import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import strings from "../../../localization/strings"
import { IOccupationInfo } from "../../../models"
import ChooseOccupationDialogForChip from "./ChooseOccupationDialogForChip"
import AppStateStore from "../../../stores/AppStateStore"

interface IProps {
	readonly: boolean
	maxWidth?: number
	selectedOccupations?: IOccupationInfo[]
	handleSave(Occupations: IOccupationInfo[]): void
	handleDelete(Occupations: IOccupationInfo[]): void
}
interface IState {
	selectedOccupations: IOccupationInfo[]
	openChooseDialog: boolean
}

export default class ChooseOccupationChip extends React.Component<IProps, IState>  {
	constructor(props) {
		super(props)
		this.state = {
			selectedOccupations: props.selectedOccupations,
			openChooseDialog: false,
		}
	}

	render() {
		return !(this.props.readonly && this.props.selectedOccupations.length === 0) && (
			<div style={{ paddingTop: 20, width: 350 }}>
				<div style={{ fontSize: 12, color: "rgba(0, 0, 0, 0.298)" }}>
					{strings.Occupations}
				</div>
				<div style={{ display: "flex", flexWrap: "wrap", }}>
					{this.state.selectedOccupations && this.state.selectedOccupations.length > 0 &&
						this.state.selectedOccupations.map((occupation, index) => (
							<Chip
								key={index}
								style={{ margin: 2, height: 35, width: "min-content", }}
								onRequestDelete={this.props.readonly ?
									null :
									() => {
										const selectedOccupations = this.state.selectedOccupations.filter((_occupation, _index) => _index !== index)
										this.setState({ selectedOccupations })
										this.props.handleDelete(selectedOccupations)
									}
								}
							>
								<div
									className="TextOverflow"
									title={occupation.Name}
									style={{ maxWidth: this.props.maxWidth }}
								>
									{occupation.Name}
								</div>
							</Chip>
						))
					}
					{!this.props.readonly &&
						<IconButton
							style={{ height: 35, width: 35, padding: 0, margin: 0, display: "inline-block" }}
							onTouchTap={() => this.setState({ openChooseDialog: true })}
						>
							<FontIcon className="fa fa-plus-circle" />
						</IconButton>
					}
					{this.state.openChooseDialog &&
						<ChooseOccupationDialogForChip
							handleClose={() => this.setState({ openChooseDialog: false })}
							handleSave={selectedOccupations => {
								this.state.selectedOccupations.find(i => selectedOccupations.map(j => j.Id).includes(i.Id)) ?
									AppStateStore.setAlertDialogContent({
										content: strings.Duplicated_occupation_exist
									}) :
									this.setState({
										openChooseDialog: false,
										selectedOccupations: [...this.state.selectedOccupations, ...selectedOccupations]
									}, () =>
										this.props.handleSave(selectedOccupations)
									)
							}}
						/>
					}
				</div>
			</div>
		)
	}
}